import {
    getUnifiedReviewHistory,
    getUnifiedReviewRecords,
    saveUnifiedReviewBatchDecision,
    saveUnifiedReviewDecision,
    UNIFIED_RISK_TYPE,
} from "@/api/unifiedReviewWorkbench";

function mapClaimRiskRecord(record = {}) {
    const detailPayload = record.detailPayload || {};
    return {
        ...record,
        caseNo: record.primaryCaseNo || record.bizKey || detailPayload.caseNo || "",
        meituanCaseNo: detailPayload.meituanCaseNo || "",
        reviewStatus: record.reviewDecision || record.reviewStatus || "pending",
        recordStatus: record.recordStatus || "active",
        autoAmount: detailPayload.autoAmount,
        currentAmount: detailPayload.currentAmount,
        differenceRatio: detailPayload.differenceRatio,
        differenceValue: detailPayload.differenceValue,
        autoCalculatedFlag: detailPayload.autoCalculatedFlag,
        lastReasonCode: record.reasonCode || record.lastReasonCode,
        lastReasonDesc: record.reasonDesc || record.lastReasonDesc,
        reviewUpdatedAt: record.reviewedAt || record.updatedAt,
        updatedAt: record.updatedAt,
    };
}

function mapClaimRiskHistory(item = {}) {
    return {
        ...item,
        historyId: item.reviewHistoryId || item.historyId,
        beforeReviewStatus: item.beforeReviewDecision || item.beforeReviewStatus,
        afterReviewStatus: item.afterReviewDecision || item.afterReviewStatus,
    };
}

export function getClaimRiskReviewRecords(apiBaseurl = "", params = {}, httpClient) {
    return getUnifiedReviewRecords(apiBaseurl, {
        riskType: UNIFIED_RISK_TYPE.CLAIM_RISK,
        reviewStatus: params.reviewStatus || "all",
        reviewDecision: params.reviewDecision || "pending",
        pageNo: params.pageNo || 1,
        pageSize: params.pageSize || 20,
    }, httpClient, mapClaimRiskRecord);
}

export function getClaimRiskReviewHistory(apiBaseurl = "", riskEventId, httpClient) {
    return getUnifiedReviewHistory(apiBaseurl, riskEventId, httpClient, mapClaimRiskHistory);
}

export function saveClaimRiskReviewDecision(apiBaseurl = "", riskEventId, payload = {}, httpClient) {
    return saveUnifiedReviewDecision(apiBaseurl, riskEventId, payload, httpClient, mapClaimRiskRecord);
}

export function saveClaimRiskReviewBatchDecision(apiBaseurl = "", payload = {}, httpClient) {
    return saveUnifiedReviewBatchDecision(apiBaseurl, {
        riskType: UNIFIED_RISK_TYPE.CLAIM_RISK,
        riskEventIds: payload.riskEventIds || [],
        decision: payload.decision,
        decisionNote: payload.decisionNote,
    }, httpClient);
}
